import { useEffect } from "react";
import { captureFirstTouch } from "#/lib/analytics";

/**
 * Captures first-touch attribution once on initial mount. Mounted in `__root.tsx`
 * (NOT `_app.tsx`) so it runs on the public landing (`/`) and referral (`/r/:code`)
 * routes too, where the first ad click typically lands — those are outside the
 * `_app` layout. Write-once: re-mounts and later navigations are no-ops.
 */
export function AttributionSync() {
	useEffect(() => {
		captureFirstTouch();
	}, []);

	return null;
}
